import "../assets/css/ResponsiveDataTable.css"
import { DataTable } from "primereact/datatable";
import React from "react";
import { Paginator } from "primereact/paginator";

export const ResponsiveDataTable = (props) => {
  let _row = 0;
  const rowClass = (data) => {
    _row = _row + 1;
    return {
      whiteSmokeRow: _row % 2 === 0,
    };
  };

  return (
    <>
      <DataTable
        className="p-datatable-responsive-demo"
        {...props}
        rowClassName={rowClass}
      />
      {props.paginationConfig ? (
        <Paginator
          rows={props.paginationConfig.itemsPerPage}
          totalRecords={props.paginationConfig.totalRecords}
          first={props.paginationConfig.first}
          rowsPerPageOptions={[5, 10, 25]}
          onPageChange={props.onActivePageChange}
          template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{totalRecords} kayıttan {first} - {last} arası gösteriliyor"
        />
      ) : null}
    </>
  );
};
